import moment from 'moment';
import React from 'react';

import CommonModal from '../modals/common/Modal';
import '../../styles/organisms/system-usehistory-dialog.scss';
import { messageUtility } from '../../utilities/messageUtility';

/**
 * (システム)オプション利用履歴のダイアログ
 */
const SystemUseHistoryDialog = ({
  visible,
  systemUseHistoryList,
  isUseProgressService,
  onClose,
}) => {
  return (
    <CommonModal visible={visible} modalClassName={'SystemUseHistoryDialog'}>
      <div className='dialog-md dialog--modal'>
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>サービス利用履歴</span>
        </div>
        <div className='dialog-md__body'>
          <SystemUseHistoryList
            isUseProgressService={isUseProgressService}
            systemUseHistoryList={systemUseHistoryList}
          />
        </div>
        <div className='dialog-md__footer'>
          <button className='btn--sub' onClick={onClose}>
            {messageUtility.getMessage('I-000-008')}
          </button>
        </div>
      </div>
    </CommonModal>
  );
};

/**
 * (システム)オプション利用履歴一覧
 * */
const SystemUseHistoryList = ({
  systemUseHistoryList,
  isUseProgressService,
}) => {
  if (systemUseHistoryList && systemUseHistoryList.length === 0) {
    return (
      <div className='table__message'>
        {messageUtility.getMessage('I-000-005')}
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className={'SystemUseHistoryDialog__table'}>
        <table className='data-table'>
          <thead className='data-table__header'>
            <tr>
              <th className='data-table__head'>変更日</th>
              <th className='data-table__head'>調整会議</th>
              <th className='data-table__head'>入退場管理</th>
              <th className='data-table__head'>労務安全</th>
              {isUseProgressService && (
                <th className='data-table__head'>進捗歩掛</th>
              )}
              <th className='data-table__head'>Buildee利用終了日</th>
              <th className='data-table__head'>申請者</th>
              <th className='data-table__head'>承認者</th>
            </tr>
          </thead>
          <tbody>
            {systemUseHistoryList.map(systemUseHistoryItem => {
              return (
                <tr
                  onClick={this.selectRow}
                  className='data-table__item'
                  key={systemUseHistoryItem.id}
                >
                  {/* 変更日 */}
                  <td className='data-table__cell'>
                    {moment(
                      systemUseHistoryItem.flg_updated_at,
                      'YYYY-MM-DD HH:mm:ss'
                    ).format('YYYY/MM/DD HH:mm:ss')}
                  </td>
                  {/* 調整会議利用状況 */}
                  <td className='data-table__cell data-table__option'>
                    {systemUseHistoryItem.use_conference_flg === true
                      ? '○'
                      : '-'}
                  </td>
                  {/* 労務安全利用状況 */}
                  <td className='data-table__cell data-table__option'>
                    {systemUseHistoryItem.use_entrance_flg === true ? '○' : '-'}
                  </td>
                  {/* 入退場管理利用状況 */}
                  <td className='data-table__cell data-table__option'>
                    {systemUseHistoryItem.use_greenfile_flg === true
                      ? '○'
                      : '-'}
                  </td>
                  {/* 進捗歩掛利用状況 */}
                  {isUseProgressService && (
                    <td className='data-table__cell data-table__option'>
                      {systemUseHistoryItem.use_progress_flg === true
                        ? '○'
                        : '-'}
                    </td>
                  )}
                  {/* 利用終了日 */}
                  <td className='data-table__cell'>
                    {systemUseHistoryItem.usage_end_date === null
                      ? ''
                      : moment(
                          systemUseHistoryItem.usage_end_date,
                          'YYYY-MM-DD'
                        ).format('YYYY/MM/DD')}
                  </td>
                  {/* 申請者 */}
                  <td className='data-table__cell'>
                    {systemUseHistoryItem.applied_user_name}
                  </td>
                  {/* 承認者 */}
                  <td className='data-table__cell'>
                    {systemUseHistoryItem.approved_user_name}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </React.Fragment>
  );
};

export default SystemUseHistoryDialog;



// WEBPACK FOOTER //
// ./src/components/dialogs/SystemUseHistoryDialog.jsx